import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit'
import { initialInternalUserState } from 'store/internalUser/initial.ts'
import { createInternalUser, deleteInternalUser, getInternalUsers, updateInternalUser } from 'store/internalUser/thunks'

export const internalUserSlice = createSlice({
  name: 'internalUser',
  initialState: initialInternalUserState,
  reducers: {},
  extraReducers: (builder) => {
    // SPECIFIC THUNK REDUCERS
    builder.addCase(getInternalUsers.fulfilled, (state, { payload }) => {
      state.internalUsers = payload.internalUsers
    })

    // IS PENDING MATCHER
    builder.addMatcher(isPending(getInternalUsers, deleteInternalUser, updateInternalUser, createInternalUser), (state) => {
      state.loading = true
      state.error = undefined
    })

    // IS FULFILLED
    builder.addMatcher(isFulfilled(getInternalUsers, deleteInternalUser, updateInternalUser, createInternalUser), (state) => {
      state.loading = false
    })

    // IS REJECTED
    builder.addMatcher(isRejected(getInternalUsers, deleteInternalUser, updateInternalUser, createInternalUser), (state, err) => {
      state.loading = false
      state.error = err.payload as string
    })
  }
})

export default internalUserSlice.reducer
